(() => {
  const SELECTOR = ".splide.product-gallery-splide";
  const PROGRESS_BAR_SELECTOR = ".product-gallery-progress-bar";
  const MOBILE_BP = 749;
  const instances = new Map();
  const mql = window.matchMedia(`(max-width: ${MOBILE_BP}px)`);
  const isMobile = () => mql.matches;

  function resolveProgressBar(el) {
    const parent = el.parentElement;
    let bar = parent ? parent.querySelector(PROGRESS_BAR_SELECTOR) : null;
    if (!bar) bar = el.querySelector(PROGRESS_BAR_SELECTOR);
    return bar || null;
  }

  function updateProgress(el, splide) {
    const bar = resolveProgressBar(el);
    if (!bar) return;
    const total = splide.Components.Controller.getEnd() + 1;
    const stepWidth = 100 / total;
    const index = splide.index;

    bar.style.width = stepWidth + "%";
    bar.style.left = `${index * stepWidth}%`;
  }

  function resetProgress(el) {
    const bar = resolveProgressBar(el);
    if (bar) bar.style.left = 0;
  }

  function mount(el) {
    if (!isMobile() || instances.has(el) || typeof Splide === "undefined") return;

    const splide = new Splide(el, {
      type: "slide",
      perPage: 1,
      perMove: 1,
      arrows: false,
      pagination: false,
      drag: true,
      speed: 600,
      gap: "0.5rem",
    });

    const redraw = () => {
      updateProgress(el, splide);

      if (window.template == "product") updateZoomOpenerId(el, splide);
    };
    splide.on("mounted move updated refresh", redraw);

    splide.mount();
    instances.set(el, splide);
    redraw();
  }

  function updateZoomOpenerId(el, splide) {
    const slides = el.querySelectorAll(".splide__slide");
    const activeSlide = slides[splide.index].querySelector("side-drawer-toggle");
    const activeImageId = activeSlide.dataset.mediaId;
    const zoomButton = el.querySelector(".product-gallery-open-zoom");
    zoomButton.dataset.mediaId = activeImageId;
  }

  function destroy(el, deep = true) {
    const inst = instances.get(el);
    if (!inst) return;
    try {
      inst.destroy(deep);
    } catch (_) {}
    instances.delete(el);
    resetProgress(el);
  }

  function pruneStale() {
    for (const [el, inst] of instances.entries()) {
      if (!el.isConnected) {
        try {
          inst.destroy(true);
        } catch (_) {}
        instances.delete(el);
      }
    }
  }

  function syncToViewport() {
    pruneStale();

    const els = document.querySelectorAll(SELECTOR);

    if (!isMobile()) {
      for (const el of Array.from(instances.keys())) destroy(el, true);
      return;
    }
    els.forEach((el) => mount(el));
  }

  function refreshAll() {
    pruneStale();

    if (!isMobile()) {
      for (const el of Array.from(instances.keys())) destroy(el, true);
      return;
    }

    document.querySelectorAll(SELECTOR).forEach((el) => {
      const inst = instances.get(el);
      if (inst) {
        try {
          inst.refresh();
          updateProgress(el, inst);
        } catch (_) {}
      } else {
        mount(el);
      }
    });
  }

  const ready = () => syncToViewport();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready, { once: true });
  } else {
    ready();
  }

  if (mql.addEventListener) mql.addEventListener("change", syncToViewport);
  else mql.addListener(syncToViewport);
  document.addEventListener("mobile-gallery:refresh", refreshAll);
  document.addEventListener("shopify:section:load", refreshAll);
  document.addEventListener("shopify:section:unload", refreshAll);
})();
